import * as React from 'react';
import { Button, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  IsAllowed,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { InstitutionMemberInvite } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

interface MemberInviteSearchProps {
  type: 'admin' | 'member';
}

export const MemberInviteSearch = (props: MemberInviteSearchProps): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'invitee_email', operator: 'ct', value: '' },
        { fieldId: 'is_admin', operator: 'eq', value: props.type === 'admin', display: 'hidden' },
      ],
    },
    order: [['created_at', 'DESC']],
  } as QueryOptions);
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionMemberInvite, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(InstitutionMemberInvite, queryOptions);

  return (
    <Section
      subtitle={
        props.type === 'admin'
          ? 'Users who have been invited to become admins but have not yet registered'
          : 'Users who have been invited to become members but have not yet registered'
      }
    >
      <IsAllowed entity={InstitutionMemberInvite} action="create">
        <Stack direction="horizontal" gap={3} className="mb-3">
          <Link to={props.type === 'admin' ? '/admin/institution-member/add-admin' : '/admin/institution-member/add'}>
            <Button size="sm" variant="primary">
              Invite New {props.type === 'admin' ? 'Admin' : 'Member'} by Email Address
            </Button>
          </Link>
          {props.type !== 'admin' && (
            <Link to="/admin/institution-member/bulk-upload">
              <Button size="sm" variant="primary">
                Bulk Upload Members via CSV File
              </Button>
            </Link>
          )}
        </Stack>
      </IsAllowed>

      <PaginatorAndListSettings
        entity={InstitutionMemberInvite}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
